import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from "prop-types";
import styles from "./styles";
import { withStyles } from "@material-ui/core";
import { Link } from "react-router-dom";
import routes from "../api/routes";
import { messageShow } from "../../common/api/actions";
import SectionPaper from "../../common/SectionPaper";
import EmptyMessage from "../../common/EmptyMessage";
import { Tabs, Tab } from "@mui/material";
import { styled } from "@mui/system";
import BrandedLoading from "../../common/BrandedLoading";
import dayjs from "dayjs";
import { Paper, Button, Toolbar, Typography, Tooltip, IconButton, Modal, Box, Pagination, TextField, MenuItem, Select, Checkbox, Autocomplete, Grid, Chip } from "@mui/material";
import { Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import {
    EventAvailable as EventAvailableIcon,
    ChevronLeft as ChevronLeftIcon,
    ChevronRight as ChevronRightIcon,
    Settings as SettingsIcon,
    Close as CloseIcon,
    Check as CheckIcon,
    Delete as DeleteIcon,
    Download as DownloadIcon,
    LightbulbOutlined as LightbulbOutlinedIcon,
    Visibility as VisibilityIcon
} from "@mui/icons-material";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

import { fetchAllBookings } from '../store/bookingSlice';
import { getbookingSettings, getAllbookingsbyDate, getSlots, getAllbookings, downloadBooking } from "../api/actions/query";
import { bookTable, cancelBooking, deleteBooking } from "../api/actions/mutation";
import { checkPermission } from '../../common/Sidebar/checkPermission';

const CustomTabs = styled(Tabs)({
    borderBottom: "1px solid #ddd",
    flexGrow: 1,
});

const CustomTab = styled(Tab)({
    marginLeft: "20px",
    textTransform: "none",
});

const TabContainer = styled(Box)({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
});

class List extends Component {
    constructor(props) {
        super(props);
        this.state = {
            viewMode: "grid",
            bookings: [],
            allBookings: [],
            selectedRows: [],
            totalBookings: "",
            tables: [],
            tableCapacity: "",
            timeSlots: [],
            selectedDate: new Date(),
            holidayMessage: "",
            selectedBooking: null,
            isModalOpen: false,
            currentPage: 1,
            bookingsPerPage: 15,
            selectedReason: '',
            isReserveModalOpen: false,
            selectedTimeSlot: "",
            isReserving: false,
            loading: false,
            sortOrder: "desc" ,
            reservationDetails: {
                name: "",
                email: "",
                phoneNumber: "",
                persons: "",
                occasion: ""
            },
            permissions : {
                canView: false, 
                canEdit: false, 
                canDelete: false, 
                canCreate: false 
            },
            preferenceModalOpen: false,
            selectedPreferences: "",
            selectedTable: ""
        };
        this.tableScrollRef = React.createRef();
    }

    componentDidMount() {
        this.props.fetchAllBookings();
        this.loadTableSettings();
        this.loadBookings();
        this.loadTimeSlots();
        this.loadAllBookings();
        this.fetchPermissions();
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.selectedDate !== this.state.selectedDate) {
            this.loadTimeSlots(); // Reload slots when date changes
        }
        if (prevState.viewMode !== this.state.viewMode && this.state.viewMode === "history") {
            this.loadAllBookings();
        }
        if (prevState.viewMode !== this.state.viewMode && this.state.viewMode === "list") {
            this.props.fetchAllBookings(); 
        }
    }
    
    fetchPermissions = async () => {
        const permissions = await checkPermission('store','tableReservation');
        this.setState({ permissions });
    }

    loadTableSettings = async () => {
        const { getbookingSettings, messageShow } = this.props;
        try {
            const { data } = await getbookingSettings();
            if (data.success && data.data) {
                const maxTables = data.data.maxNoOfTable;
                const tableCapacity = data.data.tableCapacity;
                const tableList = Array.from({ length: maxTables }, (_, i) => `Table ${i + 1}`);
                this.setState({
                    tables: tableList,
                    tableCapacity
                });
            }
        } catch (error) {
            console.error("Error fetching table settings:", error);
            messageShow("Failed to load table settings.");
        }
    };

    loadBookings = async () => {
        const { getAllbookingsbyDate, messageShow } = this.props;
        const { selectedDate } = this.state;
        this.isLoadingToggle(true);
        try {
            const formattedDate = selectedDate.toISOString().split("T")[0];
            const { data } = await getAllbookingsbyDate(formattedDate);

            if (data.success && data.data) {
                const allBookings = data.data[0]?.bookings || [];
                const totalBookings = data.data[0]?.totalBookings || 0;

                const confirmedBookings = allBookings.filter(booking => booking.status === "confirmed");

                this.setState({
                    bookings: confirmedBookings,
                    totalBookings: totalBookings,
                });

            }
        } catch (error) {
            console.error("Error fetching bookings: ", error);
            messageShow("Some error occurred. Please try again.");
        } finally {
            this.isLoadingToggle(false);
        }
    };

    loadTimeSlots = async () => {
        const { getSlots, messageShow } = this.props;
        const { selectedDate } = this.state;
        const dayShort = selectedDate.toLocaleDateString("en-US", { weekday: "short" }).toUpperCase();

        try {
            const { data } = await getSlots(dayShort);
            if (data.success && data.data) {
                const slots = data.data.slots || [];

                let holidayMessage = "";
                if (data.message.includes("holiday") || data.message.includes("closed")) {
                    holidayMessage = data.message;
                }
                else if (slots.length === 0) {
                   holidayMessage = "No available slots for the selected day.";
                }

                this.setState({
                   timeSlots: slots,
                   holidayMessage
                });
            }
        } catch (error) {
            console.error("Error fetching time slots:", error);
            messageShow("Failed to load time slots.");
        }
    };

    loadAllBookings = async () => {
        const { getAllbookings, messageShow } = this.props;

        this.isLoadingToggle(true);
        try {
            const { data } = await getAllbookings();
            if (data.success && data.data) {
                this.setState({
                    allBookings: data.data,
                });
            }
        } catch (error) {
            console.error("Error fetching bookings:", error);
            messageShow("Failed to load bookings.");
        } finally {
            this.isLoadingToggle(false);
        }
    };

    refreshReservations = () => {
        this.loadBookings();
        this.loadAllBookings();
        this.loadTimeSlots();
    };    

    handleSelectAll = (event) => {
        const { allBookings } = this.state;

        if (event.target.checked) {
            this.setState({ selectedRows: allBookings.map((booking) => booking._id) });
        } else {
            this.setState({ selectedRows: [] });
        }
    };

    handleCheckboxChange = (bookingId) => {
        this.setState((prevState) => {
            const selectedRows = [...prevState.selectedRows];
            if (selectedRows.includes(bookingId)) {
                return { selectedRows: selectedRows.filter(id => id !== bookingId) };
            } else {
                return { selectedRows: [...selectedRows, bookingId] };
            }
        });
    };

    handleDeleteSelected = async () => {
        const { deleteBooking, messageShow } = this.props;
        const { selectedRows } = this.state;

        if (selectedRows.length === 0) return;

        const confirmDelete = window.confirm("Are you sure you want to delete the selected bookings?");
        if (!confirmDelete) return;
      
        try {
            const responseArray = await deleteBooking({ bookingIds: selectedRows });
            const response = Array.isArray(responseArray) ? responseArray[0] : responseArray;
            if (response && response.success) {
                messageShow(response.message);
                this.setState({ selectedRows: [] });
                this.loadAllBookings();
            }
        } catch (error) {
            console.error("Error deleting bookings:", error);
            messageShow("Failed to delete booking.");
        }
    };

    handleOpenReserveModal = (timeSlot, table) => {
        this.setState({ isReserveModalOpen: true, selectedTimeSlot: timeSlot, selectedTable: table });
    };

    handleCloseReserveModal = () => {
        this.setState({ isReserveModalOpen: false, selectedTimeSlot: "", selectedTable: "", reservationDetails: { name: "", email: "", phoneNumber: "", persons: "", occasion: "" } });
    };

    handleReservationChange = (e) => {
        const { name, value } = e.target;
        this.setState((prevState) => ({
            reservationDetails: { ...prevState.reservationDetails, [name]: value }
        }));
    };


    handleReserveTable = async (event) => {
        if (event) event.preventDefault();

        const { bookTable, messageShow } = this.props;
        const { isReserving, selectedDate, selectedTimeSlot, reservationDetails, selectedTable } = this.state;
        
        if (isReserving) return;
        this.setState({ isReserving: true });
        const formattedDate = selectedDate.toLocaleDateString("en-CA");
        const formattedTime = new Date(`2000-01-01 ${selectedTimeSlot}`).toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit", hour12: true });
        const formattedDateTime = `${formattedDate} ${formattedTime}`;

        try {
            const { data } = await bookTable({
                ...reservationDetails,
                timeSlot: formattedDateTime,
                assignedTables: [selectedTable]
            });
            if (data.success && data.data) {
                messageShow(data.message);
                this.handleCloseReserveModal();
                this.loadBookings();
            }
        } catch (error) {
            console.error("Error reserving table:", error);
            messageShow("Failed to reserve table.");
        } finally {
           this.setState({ isReserving: false });
        }
    };

    handleCancelBooking = async () => {
        const { cancelBooking, messageShow } = this.props;
        const { selectedBooking, selectedReason } = this.state;

        if (!selectedBooking) return;
        const reason = selectedReason.trim();
        if (!reason) {
            alert("Please select or provide a reason for cancellation.");
            return;
        }
        const confirmCancel = window.confirm("Are you sure you want to cancel this booking?");
        if (!confirmCancel) return;

        try {
            const { data } = await cancelBooking(selectedBooking._id, selectedReason);

            if (data.success) {
                messageShow(data.message);
                this.handleCloseModal();
                this.loadBookings();
                this.setState({ selectedReason: ""})
            } else {
                messageShow(data.message || "Failed to cancel booking.");
            }
        } catch (error) {
            console.error("Error canceling booking:", error);
            messageShow("An error occurred while canceling. Please try again.");
        }
    };

    formatTimeSlot = (timeSlot) => {
        const date = dayjs(timeSlot, "YYYY-MM-DD hh:mm A");
        return date.isValid() ? date.format("hh:mm A") : "-";
    };


    isLoadingToggle = (loading) => {
        this.setState({
            loading,
        });
    };

    changeDate = (days) => {
        this.setState(
            (prevState) => ({
                selectedDate: new Date(prevState.selectedDate.setDate(prevState.selectedDate.getDate() + days))
            }),
            () => this.loadBookings()
        );
    };

    extractDate = (timeSlot) => {
        const date = dayjs(timeSlot, "YYYY-MM-DD hh:mm A"); 
        return date.isValid() ? date.format("DD-MM-YYYY") : "-";
    };

    handleOpenModal = (booking) => {
        this.setState({ selectedBooking: booking, isModalOpen: true });
    };

    handleCloseModal = () => {
        this.setState({ isModalOpen: false, selectedBooking: null });
    };

    handleOpenPreferenceModal = (preferences) => {
        this.setState({
            preferenceModalOpen: true,
            selectedPreferences: preferences
        });
    };

    handleClosePreferenceModal = () => {
        this.setState({
            preferenceModalOpen: false,
            selectedPreferences: ""
        });
    };

    handlePageChange = (event, value) => {
        this.setState({ currentPage: value });
    };

    handleSort = () =>{
         this.setState(prevState => ({
            sortOrder: prevState.sortOrder === "asc" ? "desc" : "asc"
        }));
    }

    scrollTable = (direction) => {
     if (this.tableScrollRef.current) {
      this.tableScrollRef.current.scrollBy({
        left: direction === "left" ? -200 : 200,
        behavior: "smooth"
      });
      setTimeout(this.checkScrollButtons, 300);
     }
   };

   downloadBookings = async () => {
    const { downloadBooking, messageShow } = this.props;

    try {
      const { data } = await downloadBooking();
  
      messageShow(data.message);

      if (data.success && data.data) {
        window.open(data.data, "_blank");
      }
    
    } catch (error) {
      messageShow('There was some error. Please try again.');
      this.isLoadingToggle(false);
    }
  };

    renderHelper = () => {
        return (
            <Box sx={{ p: 2, pt: 2 }}>
                <Box 
                    sx={{ 
                        backgroundColor: '#F8F9FE', 
                        borderRadius: '8px', 
                        border: '1px solid #E9ECEF',
                        p: 3
                    }}
                >
                    <Box display="flex" alignItems="center" mb={2} sx={{ color: '#5E72E4' }}>
                        <LightbulbOutlinedIcon sx={{ mr: 1, fontSize: 20 }} />
                        <Typography variant="subtitle2" sx={{ fontWeight: 700, letterSpacing: '0.5px', textTransform: 'uppercase' }}>
                            TABLE RESERVATION QUICK TIPS
                        </Typography>
                    </Box>

                    <Grid container spacing={3}>
                        <Grid item xs={12} md={3}>
                            <Box display="flex" alignItems="flex-start">
                                <ChevronRightIcon sx={{ color: '#5E72E4', fontSize: 20, mt: '2px', mr: 1, flexShrink: 0 }} />
                                <Typography variant="body2" sx={{ color: '#525F7F', lineHeight: 1.6 }}>
                                    <span style={{ fontWeight: 600, color: '#32325D' }}>Reservation Views:</span> Switch between Grid, List, and History views to manage daily bookings or check past records.
                                </Typography>
                            </Box>
                        </Grid>

                        <Grid item xs={12} md={3}>
                            <Box display="flex" alignItems="flex-start">
                                <ChevronRightIcon sx={{ color: '#5E72E4', fontSize: 20, mt: '2px', mr: 1, flexShrink: 0 }} />
                                <Typography variant="body2" sx={{ color: '#525F7F', lineHeight: 1.6 }}>
                                    <span style={{ fontWeight: 600, color: '#32325D' }}>Manual Booking:</span> Click on any available (dashed) slot in the Grid view to manually reserve a table.
                                </Typography>
                            </Box>
                        </Grid>

                        <Grid item xs={12} md={3}>
                            <Box display="flex" alignItems="flex-start">
                                <ChevronRightIcon sx={{ color: '#5E72E4', fontSize: 20, mt: '2px', mr: 1, flexShrink: 0 }} />
                                <Typography variant="body2" sx={{ color: '#525F7F', lineHeight: 1.6 }}>
                                    <span style={{ fontWeight: 600, color: '#32325D' }}>Settings & Downloads:</span> Configure capacity and slots in Settings, or export reservation data via Download.
                                </Typography>
                            </Box>
                        </Grid>

                        <Grid item xs={12} md={3}>
                            <Box display="flex" alignItems="flex-start">
                                <ChevronRightIcon sx={{ color: '#5E72E4', fontSize: 20, mt: '2px', mr: 1, flexShrink: 0 }} />
                                <Typography variant="body2" sx={{ color: '#525F7F', lineHeight: 1.6 }}>
                                    <span style={{ fontWeight: 600, color: '#32325D' }}>Mobile App:</span> Use the admin mobile app for instant notifications and to track upcoming reservations on the go.
                                </Typography>
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
            </Box>
        )
    }

    render() {
        const { tableBooking, classes } = this.props;
        const { loading, viewMode, bookings, allBookings, totalBookings, tables, tableCapacity, selectedDate, timeSlots, holidayMessage, isModalOpen, selectedBooking, currentPage, bookingsPerPage, isReserveModalOpen, selectedTimeSlot, reservationDetails, isReserving , sortOrder, permissions, preferenceModalOpen, selectedPreferences, selectedTable } = this.state;
        const bookingData = tableBooking?.data?.data || [];
        
        const sortedBookingData = [...bookingData].sort((a, b) => {
          const dateA = new Date(a.timeSlot);
          const dateB = new Date(b.timeSlot);
          return sortOrder === "asc" ? dateA - dateB : dateB - dateA;
        });
        const indexOfLastBooking = currentPage * bookingsPerPage;
        const indexOfFirstBooking = indexOfLastBooking - bookingsPerPage;
        const currentBookings = sortedBookingData.slice(indexOfFirstBooking, indexOfLastBooking);
        const paginatedBookings = allBookings.slice(indexOfFirstBooking, indexOfLastBooking);
        const predefinedReasons = [ "No-show", "Scheduling conflict", "Customer request", "Double booking"];

        return (
            <div>
                <Toolbar className={classes.toolbar}>
                    <Typography variant="h6" color="inherit" className={classes.grow}>
                        Table Reservation
                    </Typography>                  

                { permissions.canEdit ?
                        <Link 
                            to={{
                                pathname : routes.bookingSettings.path,
                                state: {permissions}
                        }}>
                        <Tooltip title="Settings" arrow>
                            <IconButton sx={{ color: '#0d3559' }}>
                                <SettingsIcon />
                            </IconButton>
                        </Tooltip>
                    </Link>: 
                         <Tooltip title="Settings" arrow>
                            <IconButton sx={{ color: '#0d3559' }} disabled>
                                <SettingsIcon />
                            </IconButton>
                     </Tooltip>
                }
                <Tooltip title="Download" arrow disableHoverListener= {permissions.canEdit ? false : true}>
                   <IconButton
                       size="large"
                        variant="contained"
                        color="primary"
                        onClick={this.downloadBookings}
                    >
                        <DownloadIcon fontSize="medium" />
                    </IconButton>
                </Tooltip>

                </Toolbar>

                <TabContainer>
                    <CustomTabs
                        value={viewMode}
                        onChange={(event, newValue) => this.setState({ viewMode: newValue })}
                        indicatorColor="primary"
                        textColor="primary"
                    >
                        <CustomTab label="Grid" value="grid" />
                        <CustomTab label="List" value="list" />
                        <CustomTab label="History" value="history" />
                    </CustomTabs>

                    {this.state.selectedRows.length > 0 && (
                        <Tooltip title="Delete" arrow>
                            <IconButton onClick={this.handleDeleteSelected} color="error" sx={{ marginRight: '35px' }}>
                                <DeleteIcon />
                            </IconButton>
                        </Tooltip>
                    )}
                </TabContainer>
                
                <Button 
                  id="refreshReservations" 
                  style={{ display: "none" }} 
                  onClick={this.refreshReservations}
                />
                
                {loading ? (
                   <BrandedLoading />
                ) : (
                    viewMode === "grid" ? (
                        <>
                            <div className={classes.container}>
                                <div className={classes.leftSection}>
                                    <EventAvailableIcon />
                                    <Typography variant="h6" style={{ fontWeight: "bold", marginLeft: "5px" }}>
                                        {totalBookings}
                                    </Typography>
                                    <Typography variant="subtitle1" style={{ color: "gray", marginLeft: "5px" }}>
                                        total bookings
                                    </Typography>
                                </div>

                                <div className={classes.rightSection}>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                      <DatePicker
                                        label="Select Date"
                                        value={dayjs(selectedDate)}
                                        onChange={(newValue) => {
                                          if (newValue) {
                                            this.setState({ selectedDate: newValue.toDate() }, () => this.loadBookings());
                                          }
                                        }}
                                        slotProps={{
                                          textField: {
                                            size: "small",
                                            sx: { minWidth: 180 }
                                          }
                                        }}
                                      />
                                    </LocalizationProvider>
                                </div>
                            </div>

                            {holidayMessage ? (

                                <SectionPaper>
                                    <EmptyMessage message={holidayMessage} />
                                </SectionPaper>
                            ) : (
                                <>
                                <Box display="flex" justifyContent="flex-end" gap="10px" mb={1} mr={3}>
                                  <Button
                                    variant="outlined"
                                    size="small"
                                    onClick={() => this.scrollTable("left")}
                                    sx={{
                                      minWidth: "36px",
                                      width: "36px",
                                      height: "36px",
                                      borderRadius: "50%",
                                      padding: 0,
                                      bgcolor: "#F5F5F5",
                                      borderColor: '#F5F5F5',
                                      color: "#000",
                                      boxShadow: "0px 2px 4px rgba(0,0,0,0.2)",
                                      "&:hover": {
                                        bgcolor: "#F5F5F5",
                                        borderColor: '#F5F5F5',
                                        transform: "scale(1.05)",
                                        transition: "all 0.2s ease-in-out",
                                      },
                                    }}
                                   >
                                     <ChevronLeftIcon fontSize="small"/>
                                  </Button>
                                  <Button
                                    variant="outlined"
                                    size="small"
                                    onClick={() => this.scrollTable("right")}
                                    sx={{
                                      minWidth: "36px",
                                      width: "36px",
                                      height: "36px",
                                      borderRadius: "50%",
                                      padding: 0,
                                      bgcolor: "#F5F5F5",
                                      borderColor: '#F5F5F5',
                                      color: "#000",
                                      boxShadow: "0px 2px 4px rgba(0,0,0,0.2)",
                                      "&:hover": {
                                        bgcolor: "#F5F5F5",
                                        borderColor: '#F5F5F5',
                                        transform: "scale(1.05)",
                                        transition: "all 0.2s ease-in-out",
                                      },
                                    }}
                                >
                                   <ChevronRightIcon fontSize="small"/>
                                  </Button>
                                </Box>

                                <Paper className={classes.tableContainer}  ref={this.tableScrollRef}>
                                    <Table>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell className={classes.headerCell}>Time Slots</TableCell>
                                                {timeSlots.map((slot, index) => (
                                                    <TableCell key={index} className={classes.slotCell}>{slot}</TableCell>
                                                ))}
                                            </TableRow>
                                        </TableHead>

                                        <TableBody>

                                          {tables.map((table, rowIndex) => (
                                           <TableRow key={rowIndex}>
                                            <TableCell className={classes.timeCell}>{table}</TableCell>
                                              {timeSlots.map((slot, colIndex) => {
                                                const slotBookings = bookings.filter((b) => b.timeSlot === slot);
                                                const tableBooking = slotBookings.find((b) =>
                                                   b.assignedTables.includes(table)
                                                );

                                                if (tableBooking) {
                                                 if (tableBooking.assignedTables[0] === table) {
                                                   return (
                                                    <TableCell
                                                      key={colIndex}
                                                      className={classes.bookingCell}
                                                      colSpan={1}
                                                      rowSpan={tableBooking.assignedTables.length}
                                                      onClick={() => this.handleOpenModal(tableBooking)}
                                                      style={{ cursor: "pointer" }}
                                                    >
                                                      <div className={tableBooking.status === "confirmed" ? classes.confirmed : classes.emptySlot}>
                                                           {tableBooking.status === "confirmed" ? (
                                                              <CloseIcon sx={{ color: "green", fontSize: 18 }}/>
                                                            ) : (
                                                              <CheckIcon sx={{ fontSize: 18 }}/>
                                                            )}
                                                       </div>
                                                    </TableCell>
                                                   );
                                                 }
                                                 return null;
                                                }

                                                return (
                                                <TableCell key={colIndex} className={classes.bookingCell}>
                                                  <div
                                                    className={classes.emptySlot}
                                                    onClick={() => this.handleOpenReserveModal(slot, table)}
                                                  >
                                                    <CheckIcon sx={{ fontSize: 18 }} />
                                                  </div>
                                                </TableCell>
                                                );
                                              })}
                                           </TableRow>
                                          ))}
                                        </TableBody>
                                    </Table>
                                </Paper>
                                <Box
                                  display="flex"
                                  justifyContent="center"
                                  alignItems="center"
                                   gap="15px"
                                  my={1.25}
                                >
                                  <Box display="flex" alignItems="center" gap="5px">
                                    <Box
                                      width={25}
                                      height={25}
                                      bgcolor="#eeeeee"
                                      border="1px dashed #bdbdbd"
                                      borderRadius="4px"
                                      display="flex"
                                      alignItems="center"
                                      justifyContent="center"
                                    >
                                       <CheckIcon sx={{ fontSize: 16 }} />
                                    </Box>
                                    <span>Available</span>
                                  </Box>

                                  <Box display="flex" alignItems="center" gap="5px">
                                    <Box
                                      width={25}
                                      height={25}
                                      bgcolor="#daecdbff"
                                      border="1px solid #388e3c"
                                      borderRadius="4px"
                                      display="flex"
                                      alignItems="center"
                                      justifyContent="center"
                                    >
                                      <CloseIcon sx={{ color: "green", fontSize: 16 }} />
                                    </Box>
                                    <span>Booked</span>
                                  </Box>
                                </Box>
                                </>
                            )}
                        </>
                    ) : viewMode === "history" ? (
                        <Paper className={classes.tableContainer}>
                            <Table stickyHeader>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>
                                            <Checkbox
                                                indeterminate={this.state.selectedRows.length > 0 && this.state.selectedRows.length < this.state.allBookings.length}
                                                checked={this.state.selectedRows.length === this.state.allBookings.length && this.state.allBookings.length > 0}
                                                onChange={this.handleSelectAll}
                                            />
                                        </TableCell>
                                        <TableCell>Date</TableCell>
                                        <TableCell>Time Slot</TableCell>
                                        <TableCell>Name</TableCell>
                                        <TableCell>Email</TableCell>
                                        <TableCell>Phone</TableCell>
                                        <TableCell>Persons</TableCell>
                                        <TableCell>Status</TableCell>
                                        <TableCell>Special Occasion</TableCell>
                                        <TableCell>Reason</TableCell>
                                         <TableCell>Booked on</TableCell>
                                        <TableCell>Preferences</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {paginatedBookings.length > 0 ? (
                                        paginatedBookings.map((booking) => (
                                            <TableRow key={booking._id}>
                                                <TableCell>
                                                    <Checkbox
                                                        checked={this.state.selectedRows.includes(booking._id)}
                                                        onChange={() => this.handleCheckboxChange(booking._id)}
                                                    />
                                                </TableCell>
                                                <TableCell>{this.extractDate(booking.timeSlot)}</TableCell>
                                                <TableCell>{this.formatTimeSlot(booking.timeSlot)}</TableCell>
                                                <TableCell>{booking.name}</TableCell>
                                                <TableCell>
                                                    {booking.email ? booking.email : "-"}
                                                </TableCell>
                                                <TableCell>{booking.phoneNumber}</TableCell>
                                                <TableCell>{booking.persons}</TableCell>
                                                <TableCell style={{ color: "red" }}>
                                                    {booking.status === "confirmed" ? "Confirmed" : booking.status === "canceled" ? "Cancelled" : booking.status}
                                                </TableCell>
                                                <TableCell>
                                                    {booking.occasion ? booking.occasion : "-"}
                                                </TableCell>
                                                <TableCell>
                                                    {booking.reason ? booking.reason : "-"}
                                                </TableCell>
                                                <TableCell>
                                                    {booking?.createdAt ? dayjs(booking.createdAt).format("DD-MM-YYYY") : "N/A"}
                                                </TableCell>
                                                <TableCell>
                                                    {booking.preferences ? (
                                                        <Tooltip title="View Preferences" arrow>
                                                            <IconButton
                                                                onClick={() => this.handleOpenPreferenceModal(booking.preferences)}
                                                                color="primary"
                                                                size="small"
                                                            >
                                                                <VisibilityIcon fontSize="small" />
                                                            </IconButton>
                                                        </Tooltip>
                                                    ) : (
                                                        "-"
                                                    )}
                                                </TableCell>
                                            </TableRow>
                                        ))
                                    ) : (
                                        <TableRow>
                                            <TableCell colSpan={12} sx={{ textAlign: "center" }}>No Archived Reservations Found</TableCell>
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>
                        </Paper>
                    ) : (
                        <Paper className={classes.tableContainer}>
                            <Table stickyHeader>
                                <TableHead>
                                    <TableRow>
                                        <TableCell onClick={() => this.handleSort()} style={{ cursor: 'pointer' }}>
                                            Date 
                                            <span style={{ color: sortOrder === 'asc' ? '#00A4EF' : '#00A4EF', marginLeft: '5px' }}>
                                                {sortOrder === 'asc' ? '▲' : '▼'}
                                            </span>
                                        </TableCell>
                                        <TableCell>Time Slot</TableCell>
                                        <TableCell>Name</TableCell>
                                        <TableCell>Email</TableCell>
                                        <TableCell>Phone</TableCell>
                                        <TableCell>Persons</TableCell>
                                        <TableCell>Status</TableCell>
                                        <TableCell>Special Occasion</TableCell>
                                        <TableCell>Booked on</TableCell>
                                        <TableCell>Preferences</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {currentBookings.length > 0 ? (
                                        currentBookings.map((booking) => (
                                            <TableRow key={booking._id}>
                                                <TableCell>{this.extractDate(booking.timeSlot)}</TableCell>
                                                <TableCell>{this.formatTimeSlot(booking.timeSlot)}</TableCell>
                                                <TableCell>{booking.name}</TableCell>
                                                <TableCell>
                                                    {booking.email ? booking.email : "-"}
                                                </TableCell>
                                                <TableCell>{booking.phoneNumber}</TableCell>
                                                <TableCell>{booking.persons}</TableCell>
                                                <TableCell style={{ color: "green" }}>
                                                    {booking.status === "confirmed" ? "Confirmed" : booking.status}
                                                </TableCell>
                                                <TableCell>
                                                    {booking.occasion ? booking.occasion : "-"}
                                                </TableCell>
                                                <TableCell>
                                                    {booking?.createdAt ? dayjs(booking.createdAt).format("DD-MM-YYYY") : "N/A"}
                                                </TableCell>
                                                <TableCell>
                                                    {booking.preferences ? (
                                                        <Tooltip title="View Preferences" arrow>
                                                            <IconButton
                                                                onClick={() => this.handleOpenPreferenceModal(booking.preferences)}
                                                                color="primary"
                                                                size="small"
                                                            >
                                                                <VisibilityIcon fontSize="small" />
                                                            </IconButton>
                                                        </Tooltip>
                                                    ) : (
                                                        "-"
                                                    )}
                                                </TableCell>
                                            </TableRow>
                                        ))
                                    ) : (
                                        <TableRow>
                                            <TableCell colSpan={10} sx={{ textAlign: "center" }}>No Reservations Found</TableCell>
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>
                        </Paper>
                    ) 
                )}

                {selectedBooking &&
                    <Modal open={isModalOpen} onClose={this.handleCloseModal}>
                        <Box className={classes.modalContent}>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
                                <Typography variant="h6" gutterBottom>Booking Details</Typography>
                                <IconButton onClick={this.handleCloseModal}>
                                    <CloseIcon style={{ color: '#000', fontSize: '22px' }} />
                                </IconButton>
                            </Box>
                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, mb: 2 }}>
                                <Box sx={{ display: 'flex' }}>
                                    <Typography sx={{ width: '40%' }}><strong>Name</strong></Typography>
                                    <Typography sx={{ width: '60%' }}>{selectedBooking?.name || 'N/A'}</Typography>
                                </Box>
                                <Box sx={{ display: 'flex' }}>
                                    <Typography sx={{ width: '40%' }}><strong>Email</strong></Typography>
                                    <Typography sx={{ width: '60%' }}>
                                        {selectedBooking?.email ? selectedBooking.email : "-"}
                                    </Typography>
                                </Box>
                                <Box sx={{ display: 'flex' }}>
                                    <Typography sx={{ width: '40%' }}><strong>Phone</strong></Typography>
                                    <Typography sx={{ width: '60%' }}>{selectedBooking?.phoneNumber}</Typography>
                                </Box>
                                <Box sx={{ display: 'flex' }}>
                                    <Typography sx={{ width: '40%' }}><strong>No of Persons</strong></Typography>
                                    <Typography sx={{ width: '60%' }}>{selectedBooking?.persons}</Typography>
                                </Box>
                                <Box sx={{ display: 'flex' }}>
                                    <Typography sx={{ width: '40%' }}><strong>Time Slot</strong></Typography>
                                    <Typography sx={{ width: '60%' }}>{dayjs(selectedDate).format('DD-MM-YYYY')} {selectedBooking?.timeSlot}</Typography>
                                </Box>
                                <Box sx={{ display: 'flex' }}>
                                    <Typography sx={{ width: '40%' }}><strong>Booked on</strong></Typography>
                                    <Typography sx={{ width: '60%' }}>
                                       {selectedBooking?.createdAt
                                         ? dayjs(selectedBooking.createdAt).format("DD-MM-YYYY hh:mm A")
                                         : "N/A"}
                                    </Typography>
                                </Box>
                                <Box sx={{ display: 'flex' }}>
                                    <Typography sx={{ width: '40%' }}><strong>Status</strong></Typography>
                                    <Typography sx={{ width: '60%' }}>{selectedBooking?.status}</Typography>
                                </Box>
                                <Box sx={{ display: 'flex' }}>
                                    <Typography sx={{ width: '40%' }}><strong>Special Occasion</strong></Typography>
                                    <Typography sx={{ width: '60%' }}>
                                        {selectedBooking?.occasion ? selectedBooking.occasion : "-"}
                                    </Typography>
                                </Box>
                                {(selectedBooking?.preferences) && (
                                    <Box sx={{ display: 'flex' }}>
                                        <Typography sx={{ width: '40%' }}><strong>Preferences</strong></Typography>
                                        <Typography sx={{ width: '60%' }}>{selectedBooking.preferences}</Typography>
                                    </Box>
                                )}
                                <Box sx={{ display: 'flex' }}>
                                    <Typography sx={{ width: '40%' }}><strong>Assigned Tables</strong></Typography>
                                    <Typography sx={{ width: '60%' }}>
                                         {Array.isArray(selectedBooking?.assignedTables) && selectedBooking.assignedTables.length > 0
                                            ? selectedBooking.assignedTables.join(", ")
                                            : "-"}
                                    </Typography>
                                </Box>
                            </Box>
                            <Box>
                                <Typography variant="subtitle1" mt={3}>
                                    Please provide a reason for cancellation:
                                </Typography>
                                <Autocomplete
                                    freeSolo
                                    options={predefinedReasons}
                                    value={this.state.selectedReason}
                                    onChange={(e, newValue) => this.setState({ selectedReason: newValue || "" })}
                                    onInputChange={(e, newInputValue) => this.setState({ selectedReason: newInputValue })}
                                    renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Choose or Enter Reason"
                                        fullWidth
                                        margin="normal"
                                        InputProps={{
                                            ...params.InputProps,
                                            sx: {
                                                height: 50, 
                                                fontSize: '16px',
                                            },
                                        }}
                                                                        
                                    />
                                )}
                            />
                            </Box>
                            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 4, marginRight: '20px' }}>
                                <Button
                                    variant="contained"
                                    color="error"
                                    onClick={this.handleCancelBooking}
                                >
                                    Cancel Booking
                                </Button>
                            </Box>
                        </Box>
                    </Modal>
                }

                {/* Reserve Table Modal */}
                <Modal open={isReserveModalOpen} onClose={this.handleCloseReserveModal}>
                    <Box className={classes.modalContent}>
                        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
                            <Typography variant="h6">Reserve Table</Typography>
                            <IconButton onClick={this.handleCloseReserveModal}>
                                <CloseIcon />
                            </IconButton>
                        </Box>

                        <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
                            {selectedTable} | Time Slot: {dayjs(selectedDate).format('DD-MM-YYYY')} {selectedTimeSlot}
                        </Typography>
                        <form onSubmit={this.handleReserveTable}>
                            <TextField
                                fullWidth
                                margin="normal"
                                label="Name"
                                name="name"
                                required={true}
                                autoComplete="off"
                                value={reservationDetails.name}
                                onChange={this.handleReservationChange}
                            />

                            <TextField
                                fullWidth
                                margin="normal"
                                label="Phone No"
                                name="phoneNumber"
                                required={true}
                                autoComplete="off"
                                value={reservationDetails.phoneNumber}
                                onChange={this.handleReservationChange}
                            />

                            <TextField
                                fullWidth
                                margin="normal"
                                label="Email"
                                name="email"
                                required={true}
                                autoComplete="off"
                                value={reservationDetails.email}
                                onChange={this.handleReservationChange}
                            />

                            <Select
                                fullWidth
                                displayEmpty
                                name="persons"
                                required={true}
                                value={reservationDetails.persons}
                                onChange={this.handleReservationChange}
                                sx={{ mt: 2 }}
                            >
                                <MenuItem value="" disabled>
                                    Select No of Guests
                                </MenuItem>
                                {Array.from({ length: tableCapacity }, (_, i) => i + 1).map((num) => (
                                    <MenuItem key={num} value={num}>
                                        {num}
                                    </MenuItem>
                                ))}
                            </Select>

                            <Select
                                value={reservationDetails.occasion}
                                onChange={this.handleReservationChange}
                                name="occasion"
                                displayEmpty
                                fullWidth
                                sx={{ mt: 2 }}
                            >
                                <MenuItem value="" disabled>
                                    Select Special Occasion
                                </MenuItem>
                                <MenuItem value="Anniversary">Anniversary</MenuItem>
                                <MenuItem value="Birthday">Birthday</MenuItem>
                                <MenuItem value="Business Celebration">Business Celebration</MenuItem>
                                <MenuItem value="Business Meeting">Business Meeting</MenuItem>
                                <MenuItem value="Celebration">Celebration</MenuItem>
                                <MenuItem value="Engagement">Engagement</MenuItem>
                                <MenuItem value="Graduation">Graduation</MenuItem>
                                {/* <MenuItem value="Honeymoon">Honeymoon</MenuItem> */}
                            </Select>

                            <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 3 }}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    type={"submit"}
                                    disabled={isReserving}
                                >
                                    { isReserving ? "Reserving..." : "Reserve" }
                                </Button>
                            </Box>
                        </form>
                    </Box>
                </Modal>

                <Modal 
                    open={preferenceModalOpen} 
                    onClose={this.handleClosePreferenceModal}
                    aria-labelledby="modal-preference-title"
                    aria-describedby="modal-preference-description"
                >
                    <Box
                        sx={{
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            bgcolor: "white",
                            padding: 0,
                            borderRadius: "16px",
                            boxShadow: "0 10px 40px rgba(0,0,0,0.2)",
                            minWidth: "350px",
                            maxWidth: "500px",
                            width: "90%",
                            overflow: "hidden"
                        }}
                    >
                        <Box sx={{ 
                            backgroundColor: "#f4f5f7", 
                            padding: "16px 24px", 
                            borderBottom: "1px solid #e0e6ed",
                            display: "flex", 
                            justifyContent: "space-between", 
                            alignItems: "center" 
                        }}>
                            <Typography id="modal-preference-title" variant="h6" sx={{ fontWeight: 'bold', display: 'flex', alignItems: 'center', gap: 1, color: '#32325d', fontSize: '18px' }}>
                                Customer Preferences
                            </Typography>
                            <IconButton
                                aria-label="close"
                                onClick={this.handleClosePreferenceModal}
                                size="small"
                                sx={{
                                    color: "#8898aa",
                                    "&:hover": { color: "#32325d", backgroundColor: "#e9ecef" }
                                }}
                            >
                                <CloseIcon fontSize="small" />
                            </IconButton>
                        </Box>
                        
                        <Box sx={{ padding: "24px", maxHeight: '400px', overflowY: 'auto' }}>
                            <Typography variant="body1" sx={{ color: '#525f7f', whiteSpace: 'pre-wrap', lineHeight: 1.6, padding: '10px' }}>
                                {selectedPreferences}
                            </Typography>
                        </Box>
                    </Box>
                </Modal>

                {viewMode === "list" && bookingData.length > bookingsPerPage && (
                    <Pagination
                        count={Math.ceil(bookingData.length / bookingsPerPage)}
                        page={currentPage}
                        onChange={this.handlePageChange}
                        color="primary"
                        sx={{ display: "flex", justifyContent: "center", marginTop: "20px" }}
                    />
                )}

                {viewMode === "history" && allBookings.length > bookingsPerPage && (
                    <Pagination
                        count={Math.ceil(allBookings.length / bookingsPerPage)}
                        page={currentPage}
                        onChange={this.handlePageChange}
                        color="primary"
                        sx={{ display: "flex", justifyContent: "center", marginTop: "20px" }}
                    />
                )}
                {!loading && this.renderHelper()}
            </div>
        );
    }
}

List.propTypes = {
    classes: PropTypes.object.isRequired,
    fetchAllBookings: PropTypes.func.isRequired,
    messageShow: PropTypes.func.isRequired,
    getAllbookingsbyDate: PropTypes.func.isRequired,
    getbookingSettings: PropTypes.func.isRequired,
    getSlots: PropTypes.func.isRequired,
    cancelBooking: PropTypes.func.isRequired,
    bookTable: PropTypes.func.isRequired,
    getAllbookings: PropTypes.func.isRequired,
    deleteBooking: PropTypes.func.isRequired,
    downloadBooking: PropTypes.func.isRequired
};

const mapStateToProps = (state) => ({
    tableBooking: state.bookings.booking,
});

export default connect(mapStateToProps, { fetchAllBookings, messageShow, getAllbookingsbyDate, getbookingSettings, getSlots, cancelBooking, bookTable, getAllbookings, deleteBooking, downloadBooking })(withStyles(styles)(List));

